import * as React from "react";
import { Link } from "react-router-dom";
import ConnectionStore from "../../../../stores/ConnectionStore";
import { GetConnectionList } from "../../../../actions/ConnectionActions";
class ConnectionSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      connectionList: [],
      connectionsLoaded: false
    };
    this.onReceiveConnectionChange = this.onReceiveConnectionChange.bind(this);
  }
  componentDidMount() {
    ConnectionStore.addChangeListener(this.onReceiveConnectionChange);
    GetConnectionList();
  }
  componentWillUnmount() {
    ConnectionStore.removeChangeListener(this.onReceiveConnectionChange);
  }
  onReceiveConnectionChange() {
    let lastChange = ConnectionStore.lastChange();
    if (lastChange === "ConnectionList") {
      let connections = ConnectionStore.getConnections();
      this.setState({
        connectionList: connections,
        connectionsLoaded: true
      });
    }
  }
  render() {
    let listOfConnections;
    if (this.state.connectionList !== void 0) {
      listOfConnections = this.state.connectionList.map((connection) => /* @__PURE__ */ React.createElement("div", { style: { marginBottom: "8px" }, key: connection.id }, /* @__PURE__ */ React.createElement(
        Link,
        {
          className: "sidebar-link",
          to: "/Admin/ConnectionView/" + connection.id,
          style: { cursor: "Pointer", wordWrap: "break-word" }
        },
        /* @__PURE__ */ React.createElement("i", { style: { color: "#86AFC0" }, className: "fa-solid fa-database" }),
        " ",
        connection.name
      )));
    } else {
      listOfConnections = /* @__PURE__ */ React.createElement("div", null, "No connections defined");
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "d-flex flex-column p-3 text-white bg-dark",
        style: { height: "100%", width: "245px" }
      },
      /* @__PURE__ */ React.createElement(
        Link,
        {
          to: "/Admin/Connection",
          className: "d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none"
        },
        /* @__PURE__ */ React.createElement("span", { className: "fs-4" }, /* @__PURE__ */ React.createElement("i", { style: { color: "#FFCA48" }, className: "fa-solid fa-database" }), "   ", "Connections")
      ),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement("div", { style: { maxHeight: "50%", overflow: "auto" } }, listOfConnections),
      /* @__PURE__ */ React.createElement("hr", null),
      /* @__PURE__ */ React.createElement(Link, { className: "sidebar-link", to: "/Admin/ConnectionView/0" }, "New Connection")
    );
  }
}
export default ConnectionSidebar;
